import { z } from 'zod';

export const deliveryPreferenceSchema = z.discriminatedUnion('preference', [
  z
    .object({
      preference: z.enum([
        'WithinOneMonth',
        'OneToThreeMonths',
        'ThreeToSixMonths',
      ]),
    })
    .strict(),
  z
    .object({
      preference: z.literal('SpecificDate'),
      date: z.string().refine((value) => {
        const date = new Date(value + 'T00:00:00Z');
        return (
          /^\d{4}-\d{2}-\d{2}$/.test(value) &&
          value.slice(0, 4) !== '0000' &&
          Number.isFinite(date.getTime()) &&
          date.toISOString().slice(0, 10) === value
        );
      }, 'Choose a valid delivery date.'),
    })
    .strict(),
]);
export type DeliveryPreference = z.infer<typeof deliveryPreferenceSchema>;
